// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/business/accounts_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountsDatatable } from "./constants";
import type { AppsBusinessAccountsDatatableParams, AppsBusinessAccountsDatatableResult } from "./types";
import { isAppsBusinessAccountsDatatableResult } from "./validators";

export const getDataTableAppsBusinessAccountsDatatable = reactQueryTableFetcherAdapter(
  appsBusinessAccountsDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0 }: AppsBusinessAccountsDatatableParams
  ): Promise<AppsBusinessAccountsDatatableResult> => {
    return fetch(
      "/apps/business/accounts_datatable",
      "GET",
      {
        app_group_id: appGroupId,
        groupby,
        limit,
        query: serializeQueryObjects(query),
        start,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAppsBusinessAccountsDatatableResult
);
